// import React, { useEffect, useState } from "react";
// import {
// 	Table,
// 	Input,
// 	Button,
// 	Modal,
// 	Space,
// 	message,
// 	Tag,
// 	Typography,
// 	Select,
// 	Row,
// 	Col,
// 	DatePicker,
// 	InputNumber,
// 	Tabs,
// 	Divider,
// 	Steps,
// 	Radio,
// 	Spin,
// 	AutoComplete
// } from "antd";
// import * as XLSX from "xlsx";
// import { getPermissionsFromToken, hasPermission } from "../../utils/utils";

// import {
// 	PlusOutlined,
// 	ReloadOutlined,
// 	SearchOutlined,
// 	EyeOutlined,
// 	CheckOutlined,
// 	FilePdfOutlined,
// 	DownloadOutlined,
// 	TruckOutlined
// } from "@ant-design/icons";
// import {
// 	getall_facture,
// 	toggle_facture,
// 	download_facture,
// 	add_acompte,
// 	get_acompte,
// 	export_factures
// } from "../../api/factures";
// import { get_ListeRegion } from "../../api/region";
// import { get_all_agences, get_all_users } from "../../api/users";
// import { get_ListeChauffeur } from "../../api/chauffeur";
// import Notification from "../../composants/Notification";
// import "moment/locale/fr";
// import moment from "moment";
// import { get_ListeClients } from "../../api/clients";
// import { get_listeCamion } from "../../api/camion";
// import { create_commande } from "../../api/commandes";
// const { TextArea } = Input;
// const { Option } = Select
// const { RangePicker } = DatePicker;
// const commonInputStyle = {
// 	width: "100%",
// 	height: 40,
// 	display: "flex",
// 	alignItems: "center"
// };


// const Factures = () => {
// 	const [listAgence, setListeAgence] = useState([])
// 	const [listeFactures, setlisteFactures] = useState([])
// 	const [filteredFactures, setfilteredFactures] = useState([])
// 	const [loading, setLoading] = useState(false)
// 	const [searchText, setSearchText] = useState("");
// 	const [dateRange, setDateRange] = useState([]);
// 	const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
// 	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
// 	const [selectedRows, setSelectedRows] = useState([]);
// 	const [tableFilters, setTableFilters] = useState({});
// 	const [listeClient, setListeClients] = useState([]);
// 	const [listeUsers, setlisteUsers] = useState([]);
// 	const [validationModalVisible, setValidationModalVisible] = useState(false);
// 	const [factureToValidate, setFactureToValidate] = useState(null);
// 	const [showToast, setshowToast] = useState(false);
// 	const [notif, setnotif] = useState({
// 		message: null,
// 		info: null,
// 	});
// 	const [showModalAcompte, setshowModalAcompte] = useState(false)
// 	const [acompte, setacompte] = useState({
// 		"montant": null,
// 		"description": null,
// 		"facture_id": null,
// 		"user_id": localStorage.getItem('user_id')
// 	})
// 	const [showModalMobiliser, setshowModalMobiliser] = useState(false)
// 	const [listeCamions, setlisteCamions] = useState([])
// 	const [listeChauffeur, setlisteChauffeur] = useState([])
// 	const statutsValides = ["valide_direction", "valide_client", "solde"];

// 	const [selectedCamion, setSelectedCamion] = useState([
// 		{
// 			camion_id: null,
// 			chauffeur_id: null,
// 			coefficient_charge: "",
// 			coefficient_vide: "",
// 			compagnie: "COMPAGNIE MASOANDRO",
// 			agence: "Antananarivo",
// 			observation: ""
// 		}
// 	]);

// 	const [listeAcompte, setlisteAcompte] = useState([])

// 	const fetchListeCamion = async () => {
// 		const res = await get_listeCamion();
// 		if (res.status === "success") {
// 			setlisteCamions(res.data);
// 		}
// 	};

// 	const fetchListeAgence = async () => {
// 		const res = await get_all_agences();
// 		if (res.status === "success") {
// 			setListeAgence(res.data);
// 		}
// 	};

// 	const fetchListeAcompte = async (id) => {
// 		const res = await get_acompte(id);
// 		setlisteAcompte(res.data);
// 	};

// 	const fetchUsers = async () => {
// 		const res = await get_all_users();
// 		setlisteUsers(res.data);
// 	};

// 	const rowSelection = {
// 		selectedRowKeys,
// 		onChange: (keys, rows) => {
// 			setSelectedRowKeys(keys);
// 			setSelectedRows(rows);
// 		},
// 		selections: [
// 			Table.SELECTION_ALL,
// 			Table.SELECTION_INVERT,
// 			Table.SELECTION_NONE,
// 		],
// 	};

// 	const fetchExpiration = (record) => {
// 		const dateFacture = new Date(record.date_facture);
// 		const jours = Number(record.echeance_facture) || 0;
// 		const limite = new Date(dateFacture);
// 		limite.setDate(limite.getDate() + jours);
// 		const now = new Date();
// 		const isExpired = limite < now;
// 		return isExpired
// 	}

// 	const columns = [
// 		{
// 			title: "ID",
// 			dataIndex: "id",
// 			key: "id",
// 			align: "center",
// 			render: (_, record) =>
// 				<span style={{ color: fetchExpiration(record) ? "red" : "inherit" }}>{record.id}</span>

// 		},
// 		{
// 			title: "Date création",
// 			dataIndex: "created_at",
// 			key: "created_at",
// 			align: "center",
// 			render: (_, record) =>
// 				<span style={{ color: fetchExpiration(record) ? "red" : "inherit" }} >{new Date(record.created_at).toISOString().slice(0, 19).replace("T", " ")}</span>
// 		},
// 		{
// 			title: "Service",
// 			dataIndex: "service",
// 			key: "service",
// 			filters: Array.from(
// 				new Set(listeFactures?.map(item => item.service).filter(Boolean))
// 			).map(service => ({
// 				text: service,
// 				value: service,
// 			})),
// 			onFilter: (value, record) => record.service === value,

// 			render: (service) => {
// 				let color = "blue";
// 				if (service === "TRANSPORT") color = "magenta";
// 				if (service === "BENNE") color = "PURPLE";

// 				return <Tag color={color}>{service}</Tag>;
// 			},
// 		},
// 		{
// 			title: "Utilisateur",
// 			dataIndex: "user_create",
// 			key: "user_create",
// 			align: "center",

// 			// 🔹 Filtre par agence
// 			filters: listAgence.map(a => ({
// 				text: a.nom,
// 				value: `agence_${a.id}`, // on marque que c’est un filtre agence
// 			})),

// 			// 🔹 OnFilter pour gérer filtre combiné
// 			onFilter: (value, record) => {
// 				const user = listeUsers.find(u => u.id === record.user_create);
// 				if (!user) return false;

// 				// Filtre par agence
// 				if (value.startsWith("agence_")) {
// 					const agenceId = Number(value.split("_")[1]);
// 					return user.agence_id === agenceId;
// 				}

// 				// Filtre par utilisateur
// 				return user.id === value;
// 			},

// 			// 🔹 Affichage + filtres utilisateurs (dynamique selon l’agence sélectionnée)
// 			render: (_, record) => {
// 				const user = listeUsers.find(u => u.id === record.user_create);
// 				if (!user) return "—";

// 				const agence = listAgence.find(a => a.id === user.agence_id);
// 				const fullName = `${user.prenom} ${user.nom}`;

// 				// Couleur du tag selon fonction
// 				const fonctionTagColor = user.fonction_id === 1 ? "blue" : "green";

// 				return (
// 					<Space direction="vertical" size={2}>
// 						<Tag color={fonctionTagColor}>{fullName}</Tag>
// 						{agence && <Tag color="orange">{agence.nom}</Tag>}
// 					</Space>
// 				);
// 			},
// 		},
// 		{
// 			title: "Limite paiement",
// 			dataIndex: "echeance_facture",
// 			key: "echeance_facture",
// 			align: "center",
// 			render: (_, record) => {
// 				const dateFacture = new Date(record.date_facture);
// 				const jours = Number(record.echeance_facture) || 0;
// 				const limite = new Date(dateFacture);
// 				limite.setDate(limite.getDate() + jours);
// 				// Format YYYY-MM-DD HH:MM:SS
// 				const formattedDate = limite.toISOString().slice(0, 19).replace("T", " ");
// 				return (
// 					<span style={{ color: fetchExpiration(record) ? "red" : "inherit" }}>
// 						{formattedDate}
// 					</span>
// 				);
// 			},
// 		}
// 		,
// 		{
// 			title: "Référence",
// 			dataIndex: "ref_facture",
// 			key: "ref_facture",
// 			align: "center",
// 			/** ✅ Filtre Select searchable */
// 			filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
// 				/** 🔥 Liste unique des références (sans doublons) */
// 				const refs = [...new Set(listeFactures.map((f) => f.ref_facture))];

// 				return (
// 					<div style={{ padding: 10, width: 250 }}>

// 						{/* 🔍 Select avec recherche */}
// 						<Select
// 							showSearch
// 							placeholder="Choisir une référence..."
// 							style={{ width: "100%" }}

// 							value={selectedKeys[0] || undefined}

// 							options={refs.map((ref) => ({
// 								value: ref,
// 								label: ref,
// 							}))}

// 							/** Recherche dans la liste */
// 							filterOption={(input, option) =>
// 								option.label.toLowerCase().includes(input.toLowerCase())
// 							}

// 							/** Quand on sélectionne */
// 							onChange={(value) => {
// 								setSelectedKeys(value ? [value] : []);
// 								confirm();
// 							}}

// 							allowClear
// 						/>

// 						{/* 🔄 Reset filtre */}
// 						<Button
// 							style={{ marginTop: 10, width: "100%" }}
// 							onClick={() => {
// 								clearFilters();
// 								confirm();
// 							}}
// 						>
// 							Réinitialiser
// 						</Button>
// 					</div>
// 				);
// 			},

// 			/** 🎯 Filtrage réel */
// 			onFilter: (value, record) =>
// 				record.ref_facture === value,

// 			/** 🔍 Icône filtre */
// 			filterIcon: (filtered) => (
// 				<SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
// 			),

// 			/** ✅ Affichage dans la cellule */
// 			render: (_, record) => (
// 				<span style={{ color: fetchExpiration(record) ? "red" : "inherit" }}>
// 					{record.ref_facture}
// 				</span>
// 			),
// 		},

// 		{
// 			title: "Devis",
// 			dataIndex: "devis_ref",
// 			key: "devis_ref",
// 			align: "center",

// 			/** ✅ Filtre Select searchable */
// 			filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {

// 				/** 🔥 Liste unique des devis (sans doublons + ignore les valeurs vides) */
// 				const devisList = [
// 					...new Set(
// 						listeFactures
// 							.map((f) => f.devis_ref)
// 							.filter(Boolean)
// 					),
// 				];

// 				return (
// 					<div style={{ padding: 10, width: 250 }}>

// 						{/* 🔍 Select avec recherche */}
// 						<Select
// 							showSearch
// 							placeholder="Choisir un devis..."
// 							style={{ width: "100%" }}

// 							value={selectedKeys[0] || undefined}

// 							options={devisList.map((devis) => ({
// 								value: devis,
// 								label: devis,
// 							}))}

// 							/** Recherche dans la liste */
// 							filterOption={(input, option) =>
// 								option.label.toLowerCase().includes(input.toLowerCase())
// 							}

// 							/** Quand on sélectionne */
// 							onChange={(value) => {
// 								setSelectedKeys(value ? [value] : []);
// 								confirm();
// 							}}

// 							allowClear
// 						/>

// 						{/* 🔄 Reset filtre */}
// 						<Button
// 							style={{ marginTop: 10, width: "100%" }}
// 							onClick={() => {
// 								clearFilters();
// 								confirm();
// 							}}
// 						>
// 							Réinitialiser
// 						</Button>
// 					</div>
// 				);
// 			},

// 			/** 🎯 Filtrage exact */
// 			onFilter: (value, record) =>
// 				record.devis_ref === value,

// 			/** 🔍 Icône filtre */
// 			filterIcon: (filtered) => (
// 				<SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
// 			),

// 			/** ✅ Affichage */
// 			render: (_, record) => (
// 				<span style={{ color: fetchExpiration(record) ? "red" : "inherit" }}>
// 					{record.devis_ref || "-"}
// 				</span>
// 			),
// 		},

// 		{
// 			title: "Client",
// 			align: "center",
// 			dataIndex: "client_id",
// 			key: "client_id",

// 			/** ✅ Filtre personnalisé avec Select */
// 			filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
// 				<div style={{ padding: 10, width: 250 }}>

// 					{/* 🔍 Select avec recherche */}
// 					<Select
// 						showSearch
// 						placeholder="Choisir un client..."
// 						style={{ width: "100%" }}
// 						value={selectedKeys[0] || undefined}

// 						/** Liste des clients */
// 						options={listeClient.map((client) => ({
// 							value: client.id,
// 							label: client.nom,
// 						}))}

// 						/** Recherche dans le Select */
// 						filterOption={(input, option) =>
// 							option.label.toLowerCase().includes(input.toLowerCase())
// 						}

// 						/** Quand on choisit un client */
// 						onChange={(value) => {
// 							setSelectedKeys([value]);
// 							confirm();
// 						}}

// 						allowClear
// 					/>

// 					{/* 🔄 Reset filtre */}
// 					<Button
// 						style={{ marginTop: 10, width: "100%" }}
// 						onClick={() => {
// 							clearFilters();
// 							confirm();
// 						}}
// 					>
// 						Réinitialiser
// 					</Button>
// 				</div>
// 			),

// 			/** 🎯 Icône filtre */
// 			filterIcon: (filtered) => (
// 				<SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
// 			),

// 			/** ✅ Logique filtrage */
// 			onFilter: (value, record) => record.client_id === value,

// 			/** ✅ Affichage nom client */
// 			render: (_, record) => {
// 				const client = listeClient.find((c) => c.id === record.client_id);

// 				return (
// 					<span style={{ color: fetchExpiration(record) ? "red" : "inherit" }}>
// 						{client ? client.nom : "Inconnu"}
// 					</span>
// 				);
// 			},
// 		}
// 		,
// 		{
// 			title: "Status",
// 			dataIndex: "statut_facture",
// 			key: "statut_facture",
// 			align: "center",
// 			filters: [
// 				{ text: "Validé par Masoandro", value: "valide_direction" },
// 				{ text: "Refusé par Masoandro", value: "invalide_direction" },
// 				{
// 					text: "En attente de validation Masoandro",
// 					value: "attente_masoandro",
// 				},
// 				{ text: "En attente de validation Client", value: "attente_client" },
// 				{ text: "Validé par le client", value: "valide_client" },
// 				{ text: "Refusé par le client", value: "invalide_client" },
// 				{ text: "Soldé", value: "solde" },
// 			],
// 			onFilter: (value, record) => record.statut_facture === value,
// 			render: (status) => {
// 				let color = "default";
// 				let text = status;

// 				switch (status) {
// 					case "valide_direction":
// 						color = "green"; // validé Masoandro → vert
// 						text = "Validé par Masoandro";
// 						break;
// 					case "invalide_direction":
// 						color = "red"; // refusé Masoandro → rouge
// 						text = "Refusé par Masoandro";
// 						break;
// 					case "attente_masoandro":
// 						color = "orange"; // en attente Masoandro → orange
// 						text = "En attente de validation Masoandro";
// 						break;
// 					case "attente_client":
// 						color = "blue"; // en attente client → bleu
// 						text = "En attente de validation Client";
// 						break;
// 					case "valide_client":
// 						color = "cyan"; // validé client → cyan clair
// 						text = "Validé par le client";
// 						break;
// 					case "invalide_client":
// 						color = "magenta"; // refusé client → magenta / rose
// 						text = "Refusé par le client";
// 						break;
// 					case "solde":
// 						color = "#006400"; // refusé client → magenta / rose
// 						text = "Soldé";
// 						break;
// 					default:
// 						color = "default";
// 						text = "Inconnu";
// 				}

// 				return <Tag color={color}>{text}</Tag>;
// 			},
// 		},
// 		{
// 			title: "Action",
// 			key: "action",
// 			render: (_, record) => (
// 				<Space size="middle">
// 					{
// 						hasPermission(getPermissionsFromToken(), "FACTURE_ADD_ACOMPTE") && <Button
// 							className="btn btn-info btn-sm"
// 							onClick={() => onAddAcompte(record)}
// 							title="Ajouter une avance"
// 						>
// 							<PlusOutlined />
// 						</Button>
// 					}


// 					{
// 						hasPermission(getPermissionsFromToken(), "FACTURE_CHANGE_STATUS") && <Button
// 							className="btn btn-success btn-sm"
// 							onClick={() => openValidationModal(record)}
// 							title="Valider la facture"
// 						>
// 							<CheckOutlined />
// 						</Button>
// 					}

// 					{
// 						statutsValides.includes(record.statut_facture) &&
// 						hasPermission(getPermissionsFromToken(), "FACTURE_DOWNLOAD") && (
// 							<Button
// 								onClick={() => handleDownload(record)}
// 								className="btn btn-secondary btn-sm"
// 								title="Télécharger la facture"
// 							>
// 								<FilePdfOutlined />
// 							</Button>
// 						)
// 					}

// 					{
// 						statutsValides.includes(record.statut_facture) &&
// 						hasPermission(getPermissionsFromToken(), "FACTURE_GENERATE_BON_COMMANDE") && (
// 							<Button
// 								onClick={() => handleMobiliser(record)}
// 								className="btn btn-warning btn-sm"
// 								title="Mobiliser les camions"
// 							>
// 								<TruckOutlined />
// 							</Button>
// 						)
// 					}

// 				</Space>
// 			),
// 		}
// 	];

// 	useEffect(() => {
// 		fetchListeAgence()
// 		fetchUsers()
// 		fetchFacture()
// 		fetchListeClients()
// 		fetchListeCamion()
// 		fetchListeChauffeurs()
// 	}, []);

// 	const onAddAcompte = (record) => {
// 		setFactureToValidate(record)
// 		setacompte(prev => ({ ...prev, "facture_id": record.id }));
// 		fetchListeAcompte(record.id)
// 		setshowModalAcompte(true)
// 	}

// 	const fetchListeClients = async () => {
// 		const res = await get_ListeClients();
// 		setListeClients(res.data);
// 	};

// 	const fetchListeChauffeurs = async () => {
// 		const res = await get_ListeChauffeur();
// 		setlisteChauffeur(res.data);
// 	};

// 	const fetchFacture = async (range = []) => {
// 		try {
// 			setLoading(true);
// 			let start, end;
// 			if (range.length === 2) {
// 				start = moment(range[0]).format("YYYY-MM-DD HH:mm:ss");
// 				end = moment(range[1]).format("YYYY-MM-DD HH:mm:ss");
// 			} else {
// 				end = moment().format("YYYY-MM-DD HH:mm:ss");
// 				start = moment().subtract(3, "months").format("YYYY-MM-DD HH:mm:ss");
// 			}
// 			const res = await getall_facture({ start, end });
// 			console.log(res.data);
// 			if (res.data && Array.isArray(res.data)) {
// 				setlisteFactures(res.data);
// 				setfilteredFactures(res.data);
// 			} else {
// 				message.warning("Aucune donnée trouvée.");
// 			}
// 		} catch (error) {
// 			message.error("Erreur lors du chargement des factures");
// 		} finally {
// 			setLoading(false);
// 		}
// 	};


// 	const handleSearch = (e) => {
// 		const value = e.target.value.toLowerCase();
// 		setSearchText(value);
// 		const filtered = listeFactures.filter((item) => {
// 			const ref = item.ref?.toLowerCase?.() || "";
// 			const desc = item.description?.toLowerCase?.() || "";
// 			const client = item.client_nom?.toLowerCase?.() || "";
// 			return (
// 				ref.includes(value) || desc.includes(value) || client.includes(value)
// 			);
// 		});
// 		setfilteredFactures(filtered);
// 	};

// 	const handleDateChange = (dates) => {
// 		setDateRange(dates);
// 	};

// 	const handleTableChange = (pag, filters, sorter) => {
// 		setPagination(pag);
// 		setTableFilters(filters);
// 	};

// 	const closeValidationModal = () => {
// 		setValidationModalVisible(false);
// 	};

// 	const closeMobilisationModal = () => {
// 		setSelectedCamion([
// 			{
// 				camion: null,
// 				coefficient_charge: 0,
// 				coefficient_vide: 0,
// 				compagnie: "COMPAGNIE MASOANDRO",
// 				agence: "Antananarivo",
// 				observation: ""
// 			}
// 		])
// 		setshowModalMobiliser(false);
// 	};

// 	const openValidationModal = (record) => {
// 		setFactureToValidate(record)
// 		setValidationModalVisible(true);
// 	};

// 	const handleValidateFacture = async () => {
// 		if (!factureToValidate) return;
// 		const res = await toggle_facture(factureToValidate.id, factureToValidate?.statut_facture);
// 		if (res.status === "success") {
// 			setnotif({
// 				...notif,
// 				message: "Facture mise à jour avec succés",
// 				info: "success",
// 			});
// 			setshowToast(true);
// 			setTimeout(() => {
// 				window.location.reload();
// 			}, 1500);
// 		} else {
// 			message.warning("Erreur lors de la modification du facture !!!");
// 			setnotif({
// 				...notif,
// 				message: "Erreur lors de la modification du facture !!!",
// 				info: "error",
// 			});
// 			setshowToast(true);
// 			setTimeout(() => {
// 				setshowToast(false);
// 			}, 1500);
// 		}
// 	}

// 	const handleDownload = async (record) => {
// 		console.log("DOWNLOAD CLICK", record.id);
// 		const res = await download_facture(record)

// 	}

// 	const handleMobiliser = async (record) => {
// 		setFactureToValidate(record);
// 		const coeffCharge = record.coefficient_charge
// 		const coeffVide = record.coefficient_vide
// 		console.log(record);
// 		console.log(coeffVide);

// 		updateCamionField(0, "coefficient_charge", coeffCharge);
// 		updateCamionField(0, "coefficient_vide", coeffVide);
// 		setshowModalMobiliser(true);
// 	};

// 	const addCamion = () => {
// 		const item = {
// 			camion_id: null,
// 			observation: "",
// 			coefficient_charge: parseInt(factureToValidate.coefficient_charge || 0, 10),
// 			coefficient_vide: parseInt(factureToValidate.coefficient_vide || 0, 10),
// 			compagnie: "COMPAGNIE MASOANDRO",
// 			agence: "Antananarivo",
// 		}
// 		setSelectedCamion([...selectedCamion, item]);
// 	};

// 	const removeCamion = (index) => {
// 		const updated = [...selectedCamion];
// 		updated.splice(index, 1);
// 		setSelectedCamion(updated);
// 	};

// 	const updateCamionField = (index, field, value) => {
// 		setSelectedCamion(prev =>
// 			prev.map((item, i) =>
// 				i === index ? { ...item, [field]: value } : item
// 			)
// 		);
// 	};

// 	const handleValidateMobilisation = async () => {
// 		const res = await create_commande(factureToValidate.id, selectedCamion)
// 		if (res.status === "success") {
// 			setnotif({
// 				...notif,
// 				message: "Bon de commande generé  avec succés",
// 				info: "success",
// 			});
// 			setshowToast(true);
// 			setTimeout(() => {
// 				window.location.reload();
// 			}, 1500);
// 		} else {
// 			message.warning("Erreur lors de la generation des bons de commandes !!!");
// 			setnotif({
// 				...notif,
// 				message: "Erreur lors de la generation bon de commandes !!!",
// 				info: "error",
// 			});
// 			setshowToast(true);
// 			setTimeout(() => {
// 				setshowToast(false);
// 			}, 1500);
// 		}
// 	}

// 	const handleSubmitAcompte = async () => {
// 		setacompte(prev => ({ ...prev, "user_id": localStorage.getItem('user_id') }));
// 		const res = await add_acompte(acompte)
// 		if (res.status === "success") {
// 			setnotif({
// 				...notif,
// 				message: "Acompte ajouté  avec succés",
// 				info: "success",
// 			});
// 			setshowToast(true);
// 			setTimeout(() => {
// 				window.location.reload();
// 			}, 1500);
// 		} else {
// 			message.warning("Erreur lors de l' ajout de l'acompte !!!");
// 			setnotif({
// 				...notif,
// 				message: "Erreur lors de l' ajout de l'acompte !!!",
// 				info: "error",
// 			});
// 			setshowToast(true);
// 			setTimeout(() => {
// 				setshowToast(false);
// 			}, 1500);
// 		}
// 	}

// 	const columnsAcomptes = [
// 		{
// 			title: "ID",
// 			dataIndex: "id",
// 			key: "id",
// 			align: "center",
// 			render: (_, record) =>
// 				<span style={{ color: fetchExpiration(record) ? "red" : "inherit" }}>{record.id}</span>

// 		},
// 		{
// 			title: "Date création",
// 			dataIndex: "create_at",
// 			key: "create_at",
// 			align: "center",
// 			render: (_, record) =>
// 				<span style={{ color: fetchExpiration(record) ? "red" : "inherit" }} >{new Date(record.create_at).toISOString().slice(0, 19).replace("T", " ")}</span>
// 		},
// 		{
// 			title: "User",
// 			dataIndex: "user_id",
// 			key: "user_id",
// 			filters: listeUsers.map((u) => ({
// 				text: u.prenom,
// 				value: u.id,
// 			})),
// 			align: "center",
// 			onFilter: (value, record) => record.user_id === value,
// 			render: (userId) => {
// 				const user = listeUsers.find((u) => u.id === userId);
// 				return <Tag color="blue">{user ? user.prenom : "Inconnu"}</Tag>;
// 			},
// 		},
// 		{
// 			title: "Montant",
// 			dataIndex: "montant",
// 			key: "montant",
// 			render: (v) => `${Number(v).toLocaleString()}`,
// 		},
// 		{
// 			title: "Description",
// 			dataIndex: "description",
// 			key: "description",
// 		},
// 	];

// 	const exportToExcel = () => {
// 		const exportData = listeAcompte.map((record) => {
// 			const row = {};

// 			columnsAcomptes.forEach((col) => {
// 				if (!col.dataIndex) return;

// 				let value;

// 				// 🔥 CAS SPÉCIAL : montant → nombre
// 				if (col.dataIndex === "montant") {
// 					value = Number(record.montant) || 0;
// 				}
// 				// 👉 autres colonnes : on garde le rendu du tableau
// 				else if (col.render) {
// 					const rendered = col.render(record[col.dataIndex], record);

// 					value =
// 						typeof rendered === "object" && rendered?.props?.children
// 							? rendered.props.children
// 							: rendered;
// 				} else {
// 					value = record[col.dataIndex];
// 				}

// 				row[col.title] = value;
// 			});

// 			return row;
// 		});

// 		const worksheet = XLSX.utils.json_to_sheet(exportData);

// 		// 🧠 BONUS : format Excel numérique
// 		const montantColIndex = columnsAcomptes.findIndex(
// 			(c) => c.dataIndex === "montant"
// 		);

// 		if (montantColIndex !== -1) {
// 			const colLetter = XLSX.utils.encode_col(montantColIndex);
// 			Object.keys(worksheet).forEach((cell) => {
// 				if (cell.startsWith(colLetter) && cell !== `${colLetter}1`) {
// 					worksheet[cell].t = "n"; // number
// 					worksheet[cell].z = "#,##0"; // format Excel
// 				}
// 			});
// 		}

// 		const workbook = XLSX.utils.book_new();
// 		XLSX.utils.book_append_sheet(workbook, worksheet, "Acomptes");
// 		XLSX.writeFile(
// 			workbook,
// 			`${factureToValidate["ref_facture"]}_acomptes.xlsx`
// 		);
// 	};

// 	const handleExport = async () => {
// 		const params = new URLSearchParams();
// 		if (dateRange.length === 2) {
// 			params.append(
// 				"start",
// 				moment(dateRange[0]).format("YYYY-MM-DD HH:mm:ss")
// 			);
// 			params.append("end", moment(dateRange[1]).format("YYYY-MM-DD HH:mm:ss"));
// 		} else {
// 			// Si pas de date sélectionnée, 3 derniers mois par défaut
// 			params.append("end", moment().format("YYYY-MM-DD HH:mm:ss"));
// 			params.append(
// 				"start",
// 				moment().subtract(3, "months").format("YYYY-MM-DD HH:mm:ss")
// 			);
// 		}
// 		// Autres filtres du tableau
// 		if (tableFilters.region_depart?.length)
// 			params.append("region_depart", tableFilters.region_depart.join(","));
// 		if (tableFilters.region_arrive?.length)
// 			params.append("region_arrive", tableFilters.region_arrive.join(","));
// 		if (tableFilters.client_nom?.length)
// 			params.append("client", tableFilters.client_nom.join(","));
// 		if (tableFilters.user_create_id?.length)
// 			params.append("commercial", tableFilters.user_create_id.join(","));
// 		if (tableFilters.statut_facture?.length)
// 			params.append("statut", tableFilters.statut_facture.join(","));

// 		console.log(tableFilters);
// 		const res = await export_factures(params.toString());
// 	};


// 	return (
// 		<div className="p-0">
// 			<div className="flex justify-between items-center mb-4">
// 				<Space style={{ width: "85%" }}>
// 					<Input
// 						placeholder="🔍 Rechercher..."
// 						value={searchText}
// 						onChange={handleSearch}
// 						prefix={<SearchOutlined />}
// 						style={{ width: 250 }}
// 					/>
// 					<RangePicker
// 						showTime={{
// 							defaultValue: [
// 								moment("00:00:00", "HH:mm:ss"),
// 								moment("00:00:00", "HH:mm:ss"),
// 							],
// 						}}
// 						onChange={handleDateChange} size="small"
// 					/>
// 					<Button
// 						icon={<ReloadOutlined />}
// 						onClick={() => fetchFacture(dateRange)}
// 						loading={loading}
// 						style={{
// 							backgroundColor: "#0d6efd",
// 							borderColor: "#0d6efd",
// 							color: "#fff",
// 						}}
// 					>
// 						Recharger
// 					</Button>
// 					{
// 						hasPermission(getPermissionsFromToken(), "FACTURE_EXPORT") && <Button
// 							icon={<PlusOutlined />}
// 							style={{
// 								backgroundColor: "#198754",
// 								borderColor: "#198754",
// 								color: "#fff",
// 							}}
// 							onClick={handleExport}
// 						>
// 							Exporter
// 						</Button>
// 					}

// 				</Space>
// 			</div>
// 			<Spin spinning={loading}>
// 				<div style={{
// 					height: '70vh',
// 					overflowY: "auto"
// 				}}>
// 					<Table
// 						rowKey="id"
// 						columns={columns}
// 						dataSource={filteredFactures}
// 						loading={loading}
// 						pagination={{
// 							pageSize: 10,
// 							position: ["bottomCenter"],
// 							className: "custom-pagination",
// 							style: {
// 								display: "flex",
// 								justifyContent: "center",
// 								marginTop: 12,
// 							},
// 							itemRender: (page, type, originalElement) => {
// 								if (type === "page") {
// 									return (
// 										<div
// 											style={{
// 												borderRadius: "50%",
// 												minWidth: 32,
// 												height: 32,
// 												display: "flex",
// 												alignItems: "center",
// 												justifyContent: "center",
// 												border: "1px solid #d9d9d9",
// 											}}
// 										>
// 											{page}
// 										</div>
// 									);
// 								}
// 								return originalElement;
// 							},
// 						}}
// 						onChange={handleTableChange}
// 						rowSelection={rowSelection} // ✅ ajouté ici
// 					/>
// 				</div>
// 			</Spin>

// 			<Modal
// 				title={"Validation facture"}
// 				open={validationModalVisible}
// 				onCancel={closeValidationModal}
// 				footer={[
// 					<Button key="cancel" onClick={closeValidationModal}>
// 						Annuler
// 					</Button>,
// 					<Button key="confirm" type="primary" onClick={handleValidateFacture} >
// 						Confirmer
// 					</Button>,
// 				]}
// 			>
// 				<Row>
// 					<Col span={6}>
// 						<p>Choisir le statut :</p>
// 					</Col>
// 					<Col span={18} style={{ padding: 10 }}>
// 						<Select
// 							size="large"
// 							style={{ width: "100%" }}
// 							value={factureToValidate?.statut_facture ?? "attente_masoandro"}
// 							onChange={(value) => {
// 								setFactureToValidate((prev) => ({
// 									...prev,
// 									statut_facture: value,
// 								}))
// 							}}
// 						>
// 							{
// 								hasPermission(getPermissionsFromToken(), "VALIDATE_FACTURE") && <Option value="valide_direction">Validé par Masoandro</Option>
// 							}

// 							{
// 								hasPermission(getPermissionsFromToken(), "VALIDATE_FACTURE") && <Option value="invalide_direction">Invalidé par Masoandro</Option>
// 							}

// 							<Option value="attente_masoandro">
// 								En attente de validation Masoandro
// 							</Option>
// 							<Option value="attente_client">
// 								En attente de validation Client
// 							</Option>
// 							<Option value="valide_client">Validé par le Client</Option>
// 							<Option value="invalide_client">Invalidé par le Client</Option>
// 							<Option value="solde">Soldé</Option>

// 						</Select>
// 					</Col>
// 				</Row>
// 			</Modal>

// 			<Modal
// 				title="Mobilisation Camions"
// 				open={showModalMobiliser}
// 				onCancel={closeMobilisationModal}
// 				footer={[
// 					<Button key="cancel" onClick={closeMobilisationModal}>Annuler</Button>,
// 					<Button key="confirm" type="primary" onClick={handleValidateMobilisation}>
// 						Confirmer
// 					</Button>,
// 				]}
// 				style={{ top: 15 }}
// 				width="70%"
// 			>

// 				{selectedCamion && selectedCamion.map((item, index) => (
// 					<div key={index} style={{
// 						border: "1px solid #e5e5e5",
// 						borderRadius: 8,
// 						padding: 15,
// 						marginBottom: 20,
// 						background: "#fafafa"
// 					}}>

// 						{/* Ligne Camion + Coeffs */}
// 						<Row gutter={12} align="middle">
// 							<Col span={6}>
// 								<Select
// 									size="large"
// 									placeholder="Choisir camion"
// 									style={{ ...commonInputStyle, marginTop: 25 }}
// 									value={item.camion_id}
// 									onChange={(val) => {
// 										const camion = listeCamions.find(c => c.id === val);
// 										updateCamionField(index, "camion_id", val);
// 										if (camion?.chauffeur_id) {
// 											updateCamionField(index, "chauffeur_id", camion.chauffeur_id);
// 										}
// 									}}
// 								>
// 									{listeCamions?.map(c => (
// 										<Option key={c.id} value={c.id}>{c.imm}</Option>
// 									))}
// 								</Select>
// 							</Col>

// 							<Col span={6}>
// 								<Select
// 									size="large"
// 									placeholder="Choisir chauffeur"
// 									style={{ ...commonInputStyle, marginTop: 25, textAlign: "center" }}
// 									value={item.chauffeur_id}
// 									onChange={(val) => updateCamionField(index, "chauffeur_id", val)}
// 								>
// 									{listeChauffeur?.map(c => (
// 										<Option key={c.id} value={c.id}>{c.prenom}</Option>
// 									))}
// 								</Select>
// 							</Col>

// 							<Col span={4} style={{ textAlign: "center" }}>
// 								<span style={{ fontWeight: 500 }}>Coeff chargé</span>
// 								<Input
// 									value={item.coefficient_charge ?? ""}
// 									onChange={(e) => updateCamionField(index, "coefficient_charge", e.target.value)}
// 									style={{ ...commonInputStyle, paddingTop: 10, background: "#fff" }}
// 									placeholder="ex: 0.3"
// 								/>
// 							</Col>

// 							<Col span={4} style={{ textAlign: "center" }}>
// 								<span style={{ fontWeight: 500 }}>Coeff vide</span>
// 								<Input
// 									value={item.coefficient_vide ?? ""}
// 									onChange={(e) => updateCamionField(index, "coefficient_vide", e.target.value)}
// 									style={{ ...commonInputStyle, paddingTop: 10, background: "#fff" }}
// 									placeholder="ex: 0.3"
// 								/>
// 							</Col>

// 							<Col span={4} style={{ textAlign: "center" }}>
// 								<Button
// 									danger
// 									type="primary"
// 									style={{ ...commonInputStyle, marginTop: 26, textAlign: "center" }}
// 									onClick={() => removeCamion(index)}
// 									disabled={selectedCamion.length === 1}
// 								>
// 									Supprimer
// 								</Button>
// 							</Col>

// 						</Row>

// 						{/* Ligne compagnie + agence */}
// 						<Row gutter={12} style={{ marginTop: 15 }} align="middle">
// 							<Col span={12}>
// 								<label style={{ fontWeight: 500 }}>Compagnie</label>
// 								<Input
// 									placeholder="Nom de la compagnie"
// 									value={item.compagnie}
// 									onChange={(e) => updateCamionField(index, "compagnie", e.target.value)}
// 									style={{ marginTop: 5 }}
// 								/>
// 							</Col>

// 							<Col span={12}>
// 								<label style={{ fontWeight: 500 }}>Agence</label>
// 								<Input
// 									placeholder="Agence"
// 									value={item.agence}
// 									onChange={(e) => updateCamionField(index, "agence", e.target.value)}
// 									style={{ marginTop: 5 }}
// 								/>
// 							</Col>
// 						</Row>

// 						{/* Observation */}
// 						<Row style={{ marginTop: 15 }}>
// 							<Col span={24}>
// 								<TextArea
// 									rows={3}
// 									placeholder="Observation"
// 									value={item.observation}
// 									onChange={(e) =>
// 										updateCamionField(index, "observation", e.target.value)
// 									}
// 								/>
// 							</Col>
// 						</Row>

// 					</div>
// 				))}
// 				<Button type="dashed" block size="large" onClick={addCamion}>
// 					+ Ajouter un camion
// 				</Button>

// 			</Modal>

// 			<Modal
// 				title="Ajouter une avance"
// 				open={showModalAcompte}
// 				width={850}
// 				onCancel={() => {
// 					setshowModalAcompte(false);
// 					setacompte({
// 						montant: null,
// 						description: null,
// 						facture_id: null,
// 						user_id: localStorage.getItem("user_id"),
// 					});
// 					setlisteAcompte([])
// 					setFactureToValidate(null)
// 				}}
// 				footer={[
// 					<Button key="cancel" onClick={() => {
// 						setshowModalAcompte(false);
// 						setacompte({
// 							montant: null,
// 							description: null,
// 							facture_id: null,
// 							user_id: localStorage.getItem("user_id"),
// 						});
// 						setlisteAcompte([])
// 						setFactureToValidate(null)
// 					}}>
// 						Annuler
// 					</Button>,
// 					<Button key="confirm" type="primary" onClick={handleSubmitAcompte}>
// 						Confirmer
// 					</Button>,
// 				]}
// 			>
// 				{/* TABLEAU DES ACOMPTES */}
// 				<div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
// 					<Button
// 						type="primary"
// 						icon={<DownloadOutlined />}
// 						onClick={exportToExcel}
// 					>
// 						Télécharger Excel
// 					</Button>
// 				</div>

// 				<Table
// 					columns={columnsAcomptes}
// 					dataSource={listeAcompte}
// 					pagination={{
// 						pageSize: 5,
// 						position: ["bottomCenter"],
// 						className: "custom-pagination",
// 						style: {
// 							display: "flex",
// 							justifyContent: "center",
// 							marginTop: 12,
// 						},
// 						itemRender: (page, type, originalElement) => {
// 							if (type === "page") {
// 								return (
// 									<div
// 										style={{
// 											borderRadius: "50%",
// 											minWidth: 32,
// 											height: 32,
// 											display: "flex",
// 											alignItems: "center",
// 											justifyContent: "center",
// 											border: "1px solid #d9d9d9",
// 										}}
// 									>
// 										{page}
// 									</div>
// 								);
// 							}
// 							return originalElement;
// 						},
// 					}}
// 					size="small"
// 					bordered
// 				/>
// 				{/* FORMULAIRE */}
// 				<Row gutter={[16, 16]}>
// 					<Col span={6}>Montant</Col>
// 					<Col span={18}>
// 						<Input
// 							type="number"
// 							value={acompte.montant}
// 							onChange={(e) =>
// 								setacompte((prev) => ({ ...prev, montant: e.target.value }))
// 							}
// 						/>
// 					</Col>

// 					<Col span={6}>Description</Col>
// 					<Col span={18}>
// 						<TextArea
// 							rows={2}
// 							value={acompte.description}
// 							onChange={(e) =>
// 								setacompte((prev) => ({ ...prev, description: e.target.value }))
// 							}
// 						/>
// 					</Col>
// 				</Row>

// 				<Divider />


// 			</Modal>

// 			{showToast && (
// 				<Notification message={notif.message} status={notif.info} />
// 			)}
// 		</div>
// 	);
// }

// export default Factures;

import React, { useEffect, useState } from "react";
import {
	Table,
	Input,
	Button,
	Modal,
	Space,
	message,
	Tag,
	Select,
	Row,
	Col,
	DatePicker,
	Divider,
	Spin,
} from "antd";
import * as XLSX from "xlsx";
import { getPermissionsFromToken, hasPermission } from "../../utils/utils";

import {
	PlusOutlined,
	ReloadOutlined,
	SearchOutlined,
	CheckOutlined,
	FilePdfOutlined,
	DownloadOutlined,
	TruckOutlined,
} from "@ant-design/icons";
import {
	getall_facture,
	toggle_facture,
	download_facture,
	add_acompte,
	get_acompte,
	export_factures,
} from "../../api/factures";
import { get_all_agences, get_all_users } from "../../api/users";
import { get_ListeChauffeur } from "../../api/chauffeur";
import Notification from "../../composants/Notification";
import "moment/locale/fr";
import moment from "moment";
import { get_ListeClients } from "../../api/clients";
import { get_listeCamion } from "../../api/camion";
import { create_commande } from "../../api/commandes";

const { TextArea } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;

const commonInputStyle = {
	width: "100%",
	height: 40,
	display: "flex",
	alignItems: "center",
};

/* ───────────── Styles intégrés ───────────── */
const compactCss = `
.factures-page .compact-table .ant-table { font-size: 12px; }
.factures-page .compact-table .ant-table-thead > tr > th {
	font-size: 12px;
	padding: 6px 8px;
	white-space: nowrap;
}
.factures-page .compact-table .ant-table-tbody > tr > td { padding: 4px 8px; }
.factures-page .compact-table .ant-tag { margin-right: 0; }
.factures-page .compact-table .ant-btn-sm { padding: 0 6px; }
.factures-page .toolbar {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	align-items: center;
	margin-bottom: 12px;
}
`;

/* ───────────── Helpers statuts ───────────── */
const statutMap = {
	valide_direction: { color: "green", text: "Validé Masoandro" },
	invalide_direction: { color: "red", text: "Refusé Masoandro" },
	attente_masoandro: { color: "orange", text: "Attente Masoandro" },
	attente_client: { color: "blue", text: "Attente Client" },
	valide_client: { color: "cyan", text: "Validé Client" },
	invalide_client: { color: "magenta", text: "Refusé Client" },
	solde: { color: "#006400", text: "Soldé" },
};

const paginationConfig = (pageSize) => ({
	pageSize,
	position: ["bottomCenter"],
	className: "custom-pagination",
	style: {
		display: "flex",
		justifyContent: "center",
		marginTop: 12,
	},
	itemRender: (page, type, originalElement) => {
		if (type === "page") {
			return (
				<div
					style={{
						borderRadius: "50%",
						minWidth: 32,
						height: 32,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						border: "1px solid #d9d9d9",
					}}
				>
					{page}
				</div>
			);
		}
		return originalElement;
	},
});

const Factures = () => {
	const [listAgence, setListeAgence] = useState([]);
	const [listeFactures, setlisteFactures] = useState([]);
	const [filteredFactures, setfilteredFactures] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searchText, setSearchText] = useState("");
	const [dateRange, setDateRange] = useState([]);
	const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [selectedRows, setSelectedRows] = useState([]);
	const [tableFilters, setTableFilters] = useState({});
	const [listeClient, setListeClients] = useState([]);
	const [listeUsers, setlisteUsers] = useState([]);
	const [validationModalVisible, setValidationModalVisible] = useState(false);
	const [factureToValidate, setFactureToValidate] = useState(null);
	const [showToast, setshowToast] = useState(false);
	const [notif, setnotif] = useState({
		message: null,
		info: null,
	});
	const [showModalAcompte, setshowModalAcompte] = useState(false);
	const [acompte, setacompte] = useState({
		montant: null,
		description: null,
		facture_id: null,
		user_id: localStorage.getItem("user_id"),
	});
	const [showModalMobiliser, setshowModalMobiliser] = useState(false);
	const [listeCamions, setlisteCamions] = useState([]);
	const [listeChauffeur, setlisteChauffeur] = useState([]);
	const statutsValides = ["valide_direction", "valide_client", "solde"];

	const [selectedCamion, setSelectedCamion] = useState([
		{
			camion_id: null,
			chauffeur_id: null,
			coefficient_charge: "",
			coefficient_vide: "",
			compagnie: "COMPAGNIE MASOANDRO",
			agence: "Antananarivo",
			observation: "",
		},
	]);

	const [listeAcompte, setlisteAcompte] = useState([]);

	const fetchListeCamion = async () => {
		const res = await get_listeCamion();
		if (res.status === "success") {
			setlisteCamions(res.data);
		}
	};

	const fetchListeAgence = async () => {
		const res = await get_all_agences();
		if (res.status === "success") {
			setListeAgence(res.data);
		}
	};

	const fetchListeAcompte = async (id) => {
		const res = await get_acompte(id);
		setlisteAcompte(res.data);
	};

	const fetchUsers = async () => {
		const res = await get_all_users();
		setlisteUsers(res.data);
	};

	const rowSelection = {
		selectedRowKeys,
		onChange: (keys, rows) => {
			setSelectedRowKeys(keys);
			setSelectedRows(rows);
		},
		selections: [
			Table.SELECTION_ALL,
			Table.SELECTION_INVERT,
			Table.SELECTION_NONE,
		],
	};

	const fetchExpiration = (record) => {
		const dateFacture = new Date(record.date_facture);
		const jours = Number(record.echeance_facture) || 0;
		const limite = new Date(dateFacture);
		limite.setDate(limite.getDate() + jours);
		const now = new Date();
		return limite < now;
	};

	const redIf = (record) => ({
		color: fetchExpiration(record) ? "red" : "inherit",
	});

	const columns = [
		{
			title: "ID",
			dataIndex: "id",
			key: "id",
			align: "center",
			width: 60,
			render: (_, record) => <span style={redIf(record)}>{record.id}</span>,
		},
		{
			title: "Création",
			dataIndex: "created_at",
			key: "created_at",
			align: "center",
			width: 120,
			render: (_, record) => (
				<span style={redIf(record)}>
					{new Date(record.created_at)
						.toISOString()
						.slice(0, 16)
						.replace("T", " ")}
				</span>
			),
		},
		{
			title: "Service",
			dataIndex: "service",
			key: "service",
			width: 100,
			filters: Array.from(
				new Set(listeFactures?.map((item) => item.service).filter(Boolean))
			).map((service) => ({
				text: service,
				value: service,
			})),
			onFilter: (value, record) => record.service === value,
			render: (service) => {
				let color = "blue";
				if (service === "TRANSPORT") color = "magenta";
				if (service === "BENNE") color = "PURPLE";
				return <Tag color={color}>{service}</Tag>;
			},
		},
		{
			title: "Utilisateur",
			dataIndex: "user_create",
			key: "user_create",
			align: "center",
			width: 140,
			filters: listAgence.map((a) => ({
				text: a.nom,
				value: `agence_${a.id}`,
			})),
			onFilter: (value, record) => {
				const user = listeUsers.find((u) => u.id === record.user_create);
				if (!user) return false;

				if (value.startsWith("agence_")) {
					const agenceId = Number(value.split("_")[1]);
					return user.agence_id === agenceId;
				}
				return user.id === value;
			},
			render: (_, record) => {
				const user = listeUsers.find((u) => u.id === record.user_create);
				if (!user) return "—";

				const agence = listAgence.find((a) => a.id === user.agence_id);
				const fullName = `${user.prenom} ${user.nom}`;
				const fonctionTagColor = user.fonction_id === 1 ? "blue" : "green";

				return (
					<Space direction="vertical" size={2}>
						<Tag color={fonctionTagColor}>{fullName}</Tag>
						{agence && <Tag color="orange">{agence.nom}</Tag>}
					</Space>
				);
			},
		},
		// {
		// 	title: "Limite paiement",
		// 	dataIndex: "echeance_facture",
		// 	key: "echeance_facture",
		// 	align: "center",
		// 	width: 110,
		// 	render: (_, record) => {
		// 		const limite = new Date(record.date_facture);
		// 		limite.setDate(
		// 			limite.getDate() + (Number(record.echeance_facture) || 0)
		// 		);
		// 		return (
		// 			<span style={redIf(record)}>
		// 				{limite.toISOString().slice(0, 10)}
		// 			</span>
		// 		);
		// 	},
		// },
		{
			title: "Référence",
			dataIndex: "ref_facture",
			key: "ref_facture",
			align: "center",
			width: 135,
			filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
				const refs = [...new Set(listeFactures.map((f) => f.ref_facture))];

				return (
					<div style={{ padding: 10, width: 250 }}>
						<Select
							showSearch
							placeholder="Choisir une référence..."
							style={{ width: "100%" }}
							value={selectedKeys[0] || undefined}
							options={refs.map((ref) => ({
								value: ref,
								label: ref,
							}))}
							filterOption={(input, option) =>
								option.label.toLowerCase().includes(input.toLowerCase())
							}
							onChange={(value) => {
								setSelectedKeys(value ? [value] : []);
								confirm();
							}}
							allowClear
						/>
						<Button
							style={{ marginTop: 10, width: "100%" }}
							onClick={() => {
								clearFilters();
								confirm();
							}}
						>
							Réinitialiser
						</Button>
					</div>
				);
			},
			onFilter: (value, record) => record.ref_facture === value,
			filterIcon: (filtered) => (
				<SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
			),
			render: (_, record) => (
				<span style={redIf(record)}>{record.ref_facture}</span>
			),
		},
		{
			title: "Devis",
			dataIndex: "devis_ref",
			key: "devis_ref",
			align: "center",
			width: 130,
			filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
				const devisList = [
					...new Set(listeFactures.map((f) => f.devis_ref).filter(Boolean)),
				];

				return (
					<div style={{ padding: 10, width: 250 }}>
						<Select
							showSearch
							placeholder="Choisir un devis..."
							style={{ width: "100%" }}
							value={selectedKeys[0] || undefined}
							options={devisList.map((devis) => ({
								value: devis,
								label: devis,
							}))}
							filterOption={(input, option) =>
								option.label.toLowerCase().includes(input.toLowerCase())
							}
							onChange={(value) => {
								setSelectedKeys(value ? [value] : []);
								confirm();
							}}
							allowClear
						/>
						<Button
							style={{ marginTop: 10, width: "100%" }}
							onClick={() => {
								clearFilters();
								confirm();
							}}
						>
							Réinitialiser
						</Button>
					</div>
				);
			},
			onFilter: (value, record) => record.devis_ref === value,
			filterIcon: (filtered) => (
				<SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
			),
			render: (_, record) => (
				<span style={redIf(record)}>{record.devis_ref || "-"}</span>
			),
		},
		{
			title: "Client",
			align: "center",
			dataIndex: "client_id",
			key: "client_id",
			width: 160,
			ellipsis: true,
			filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
				<div style={{ padding: 10, width: 250 }}>
					<Select
						showSearch
						placeholder="Choisir un client..."
						style={{ width: "100%" }}
						value={selectedKeys[0] || undefined}
						options={listeClient.map((client) => ({
							value: client.id,
							label: client.nom,
						}))}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
						onChange={(value) => {
							setSelectedKeys([value]);
							confirm();
						}}
						allowClear
					/>
					<Button
						style={{ marginTop: 10, width: "100%" }}
						onClick={() => {
							clearFilters();
							confirm();
						}}
					>
						Réinitialiser
					</Button>
				</div>
			),
			filterIcon: (filtered) => (
				<SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
			),
			onFilter: (value, record) => record.client_id === value,
			render: (_, record) => {
				const client = listeClient.find((c) => c.id === record.client_id);
				return (
					<span style={redIf(record)}>{client ? client.nom : "Inconnu"}</span>
				);
			},
		},
		{
			title: "Status",
			dataIndex: "statut_facture",
			key: "statut_facture",
			align: "center",
			width: 150,
			filters: Object.entries(statutMap).map(([value, { text }]) => ({
				text,
				value,
			})),
			onFilter: (value, record) => record.statut_facture === value,
			render: (status) => {
				const s = statutMap[status] || { color: "default", text: "Inconnu" };
				return (
					<Tag color={s.color} style={{ margin: 0, fontSize: 11 }}>
						{s.text}
					</Tag>
				);
			},
		},
		{
			title: "Action",
			key: "action",
			align: "center",
			fixed: "right",
			width: 150,
			render: (_, record) => (
				<Space size={4}>
					{hasPermission(getPermissionsFromToken(), "FACTURE_ADD_ACOMPTE") && (
						<Button
							size="small"
							className="btn btn-info btn-sm"
							onClick={() => onAddAcompte(record)}
							title="Ajouter une avance"
						>
							<PlusOutlined />
						</Button>
					)}

					{hasPermission(getPermissionsFromToken(), "FACTURE_CHANGE_STATUS") && (
						<Button
							size="small"
							className="btn btn-success btn-sm"
							onClick={() => openValidationModal(record)}
							title="Valider la facture"
						>
							<CheckOutlined />
						</Button>
					)}

					{statutsValides.includes(record.statut_facture) &&
						hasPermission(getPermissionsFromToken(), "FACTURE_DOWNLOAD") && (
							<Button
								size="small"
								className="btn btn-secondary btn-sm"
								onClick={() => handleDownload(record)}
								title="Télécharger la facture"
							>
								<FilePdfOutlined />
							</Button>
						)}

					{statutsValides.includes(record.statut_facture) &&
						hasPermission(
							getPermissionsFromToken(),
							"FACTURE_GENERATE_BON_COMMANDE"
						) && (
							<Button
								size="small"
								className="btn btn-warning btn-sm"
								onClick={() => handleMobiliser(record)}
								title="Mobiliser les camions"
							>
								<TruckOutlined />
							</Button>
						)}
				</Space>
			),
		},
	];

	useEffect(() => {
		fetchListeAgence();
		fetchUsers();
		fetchFacture();
		fetchListeClients();
		fetchListeCamion();
		fetchListeChauffeurs();
	}, []);

	const onAddAcompte = (record) => {
		setFactureToValidate(record);
		setacompte((prev) => ({ ...prev, facture_id: record.id }));
		fetchListeAcompte(record.id);
		setshowModalAcompte(true);
	};

	const fetchListeClients = async () => {
		const res = await get_ListeClients();
		setListeClients(res.data);
	};

	const fetchListeChauffeurs = async () => {
		const res = await get_ListeChauffeur();
		setlisteChauffeur(res.data);
	};

	const fetchFacture = async (range = []) => {
		try {
			setLoading(true);
			let start, end;
			if (range.length === 2) {
				start = moment(range[0]).format("YYYY-MM-DD HH:mm:ss");
				end = moment(range[1]).format("YYYY-MM-DD HH:mm:ss");
			} else {
				end = moment().format("YYYY-MM-DD HH:mm:ss");
				start = moment().subtract(3, "months").format("YYYY-MM-DD HH:mm:ss");
			}
			const res = await getall_facture({ start, end });
			console.log(res.data);
			if (res.data && Array.isArray(res.data)) {
				setlisteFactures(res.data);
				setfilteredFactures(res.data);
			} else {
				message.warning("Aucune donnée trouvée.");
			}
		} catch (error) {
			message.error("Erreur lors du chargement des factures");
		} finally {
			setLoading(false);
		}
	};

	const handleSearch = (e) => {
		const value = e.target.value.toLowerCase();
		setSearchText(value);
		const filtered = listeFactures.filter((item) => {
			const ref = item.ref?.toLowerCase?.() || "";
			const desc = item.description?.toLowerCase?.() || "";
			const client = item.client_nom?.toLowerCase?.() || "";
			return (
				ref.includes(value) || desc.includes(value) || client.includes(value)
			);
		});
		setfilteredFactures(filtered);
	};

	const handleDateChange = (dates) => {
		setDateRange(dates);
	};

	const handleTableChange = (pag, filters, sorter) => {
		setPagination(pag);
		setTableFilters(filters);
	};

	const closeValidationModal = () => {
		setValidationModalVisible(false);
	};

	const closeMobilisationModal = () => {
		setSelectedCamion([
			{
				camion: null,
				coefficient_charge: 0,
				coefficient_vide: 0,
				compagnie: "COMPAGNIE MASOANDRO",
				agence: "Antananarivo",
				observation: "",
			},
		]);
		setshowModalMobiliser(false);
	};

	const openValidationModal = (record) => {
		setFactureToValidate(record);
		setValidationModalVisible(true);
	};

	const handleValidateFacture = async () => {
		if (!factureToValidate) return;
		const res = await toggle_facture(
			factureToValidate.id,
			factureToValidate?.statut_facture
		);
		if (res.status === "success") {
			setnotif({
				...notif,
				message: "Facture mise à jour avec succés",
				info: "success",
			});
			setshowToast(true);
			setTimeout(() => {
				window.location.reload();
			}, 1500);
		} else {
			message.warning("Erreur lors de la modification du facture !!!");
			setnotif({
				...notif,
				message: "Erreur lors de la modification du facture !!!",
				info: "error",
			});
			setshowToast(true);
			setTimeout(() => {
				setshowToast(false);
			}, 1500);
		}
	};

	const handleDownload = async (record) => {
		console.log("DOWNLOAD CLICK", record.id);
		await download_facture(record);
	};

	const handleMobiliser = async (record) => {
		setFactureToValidate(record);
		const coeffCharge = record.coefficient_charge;
		const coeffVide = record.coefficient_vide;
		console.log(record);
		console.log(coeffVide);

		updateCamionField(0, "coefficient_charge", coeffCharge);
		updateCamionField(0, "coefficient_vide", coeffVide);
		setshowModalMobiliser(true);
	};

	const addCamion = () => {
		const item = {
			camion_id: null,
			observation: "",
			coefficient_charge: parseInt(factureToValidate.coefficient_charge || 0, 10),
			coefficient_vide: parseInt(factureToValidate.coefficient_vide || 0, 10),
			compagnie: "COMPAGNIE MASOANDRO",
			agence: "Antananarivo",
		};
		setSelectedCamion([...selectedCamion, item]);
	};

	const removeCamion = (index) => {
		const updated = [...selectedCamion];
		updated.splice(index, 1);
		setSelectedCamion(updated);
	};

	const updateCamionField = (index, field, value) => {
		setSelectedCamion((prev) =>
			prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
		);
	};

	const handleValidateMobilisation = async () => {
		const res = await create_commande(factureToValidate.id, selectedCamion);
		if (res.status === "success") {
			setnotif({
				...notif,
				message: "Bon de commande generé  avec succés",
				info: "success",
			});
			setshowToast(true);
			setTimeout(() => {
				window.location.reload();
			}, 1500);
		} else {
			message.warning("Erreur lors de la generation des bons de commandes !!!");
			setnotif({
				...notif,
				message: "Erreur lors de la generation bon de commandes !!!",
				info: "error",
			});
			setshowToast(true);
			setTimeout(() => {
				setshowToast(false);
			}, 1500);
		}
	};

	const handleSubmitAcompte = async () => {
		setacompte((prev) => ({ ...prev, user_id: localStorage.getItem("user_id") }));
		const res = await add_acompte(acompte);
		if (res.status === "success") {
			setnotif({
				...notif,
				message: "Acompte ajouté  avec succés",
				info: "success",
			});
			setshowToast(true);
			setTimeout(() => {
				window.location.reload();
			}, 1500);
		} else {
			message.warning("Erreur lors de l' ajout de l'acompte !!!");
			setnotif({
				...notif,
				message: "Erreur lors de l' ajout de l'acompte !!!",
				info: "error",
			});
			setshowToast(true);
			setTimeout(() => {
				setshowToast(false);
			}, 1500);
		}
	};

	const columnsAcomptes = [
		{
			title: "ID",
			dataIndex: "id",
			key: "id",
			align: "center",
			render: (_, record) => <span style={redIf(record)}>{record.id}</span>,
		},
		{
			title: "Date création",
			dataIndex: "create_at",
			key: "create_at",
			align: "center",
			render: (_, record) => (
				<span style={redIf(record)}>
					{new Date(record.create_at)
						.toISOString()
						.slice(0, 19)
						.replace("T", " ")}
				</span>
			),
		},
		{
			title: "User",
			dataIndex: "user_id",
			key: "user_id",
			filters: listeUsers.map((u) => ({
				text: u.prenom,
				value: u.id,
			})),
			align: "center",
			onFilter: (value, record) => record.user_id === value,
			render: (userId) => {
				const user = listeUsers.find((u) => u.id === userId);
				return <Tag color="blue">{user ? user.prenom : "Inconnu"}</Tag>;
			},
		},
		{
			title: "Montant",
			dataIndex: "montant",
			key: "montant",
			render: (v) => `${Number(v).toLocaleString()}`,
		},
		{
			title: "Description",
			dataIndex: "description",
			key: "description",
		},
	];

	const exportToExcel = () => {
		const exportData = listeAcompte.map((record) => {
			const row = {};

			columnsAcomptes.forEach((col) => {
				if (!col.dataIndex) return;

				let value;

				if (col.dataIndex === "montant") {
					value = Number(record.montant) || 0;
				} else if (col.render) {
					const rendered = col.render(record[col.dataIndex], record);

					value =
						typeof rendered === "object" && rendered?.props?.children
							? rendered.props.children
							: rendered;
				} else {
					value = record[col.dataIndex];
				}

				row[col.title] = value;
			});

			return row;
		});

		const worksheet = XLSX.utils.json_to_sheet(exportData);

		const montantColIndex = columnsAcomptes.findIndex(
			(c) => c.dataIndex === "montant"
		);

		if (montantColIndex !== -1) {
			const colLetter = XLSX.utils.encode_col(montantColIndex);
			Object.keys(worksheet).forEach((cell) => {
				if (cell.startsWith(colLetter) && cell !== `${colLetter}1`) {
					worksheet[cell].t = "n";
					worksheet[cell].z = "#,##0";
				}
			});
		}

		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Acomptes");
		XLSX.writeFile(
			workbook,
			`${factureToValidate["ref_facture"]}_acomptes.xlsx`
		);
	};

	const handleExport = async () => {
		const params = new URLSearchParams();
		if (dateRange.length === 2) {
			params.append(
				"start",
				moment(dateRange[0]).format("YYYY-MM-DD HH:mm:ss")
			);
			params.append("end", moment(dateRange[1]).format("YYYY-MM-DD HH:mm:ss"));
		} else {
			params.append("end", moment().format("YYYY-MM-DD HH:mm:ss"));
			params.append(
				"start",
				moment().subtract(3, "months").format("YYYY-MM-DD HH:mm:ss")
			);
		}
		if (tableFilters.region_depart?.length)
			params.append("region_depart", tableFilters.region_depart.join(","));
		if (tableFilters.region_arrive?.length)
			params.append("region_arrive", tableFilters.region_arrive.join(","));
		if (tableFilters.client_nom?.length)
			params.append("client", tableFilters.client_nom.join(","));
		if (tableFilters.user_create_id?.length)
			params.append("commercial", tableFilters.user_create_id.join(","));
		if (tableFilters.statut_facture?.length)
			params.append("statut", tableFilters.statut_facture.join(","));

		console.log(tableFilters);
		await export_factures(params.toString());
	};

	const resetAcompteModal = () => {
		setshowModalAcompte(false);
		setacompte({
			montant: null,
			description: null,
			facture_id: null,
			user_id: localStorage.getItem("user_id"),
		});
		setlisteAcompte([]);
		setFactureToValidate(null);
	};

	return (
		<div className="p-0 factures-page">
			<style>{compactCss}</style>

			<div className="toolbar">
				<Input
					placeholder="🔍 Rechercher..."
					value={searchText}
					onChange={handleSearch}
					prefix={<SearchOutlined />}
					style={{ width: 250 }}
				/>
				<RangePicker
					showTime={{
						defaultValue: [
							moment("00:00:00", "HH:mm:ss"),
							moment("00:00:00", "HH:mm:ss"),
						],
					}}
					onChange={handleDateChange}
					size="small"
				/>
				<Button
					icon={<ReloadOutlined />}
					onClick={() => fetchFacture(dateRange)}
					loading={loading}
					style={{
						backgroundColor: "#0d6efd",
						borderColor: "#0d6efd",
						color: "#fff",
					}}
				>
					Recharger
				</Button>
				{hasPermission(getPermissionsFromToken(), "FACTURE_EXPORT") && (
					<Button
						icon={<PlusOutlined />}
						style={{
							backgroundColor: "#198754",
							borderColor: "#198754",
							color: "#fff",
						}}
						onClick={handleExport}
					>
						Exporter
					</Button>
				)}
			</div>

			<Spin spinning={loading}>
				<Table
					className="compact-table"
					size="small"
					rowKey="id"
					columns={columns}
					dataSource={filteredFactures}
					loading={loading}
					sticky
					scroll={{ x: 1100, y: "calc(70vh - 110px)" }}
					pagination={paginationConfig(10)}
					onChange={handleTableChange}
					rowSelection={rowSelection}
				/>
			</Spin>

			<Modal
				title={"Validation facture"}
				open={validationModalVisible}
				onCancel={closeValidationModal}
				footer={[
					<Button key="cancel" onClick={closeValidationModal}>
						Annuler
					</Button>,
					<Button key="confirm" type="primary" onClick={handleValidateFacture}>
						Confirmer
					</Button>,
				]}
			>
				<Row>
					<Col span={6}>
						<p>Choisir le statut :</p>
					</Col>
					<Col span={18} style={{ padding: 10 }}>
						<Select
							size="large"
							style={{ width: "100%" }}
							value={factureToValidate?.statut_facture ?? "attente_masoandro"}
							onChange={(value) => {
								setFactureToValidate((prev) => ({
									...prev,
									statut_facture: value,
								}));
							}}
						>
							{hasPermission(getPermissionsFromToken(), "VALIDATE_FACTURE") && (
								<Option value="valide_direction">Validé par Masoandro</Option>
							)}

							{hasPermission(getPermissionsFromToken(), "VALIDATE_FACTURE") && (
								<Option value="invalide_direction">Invalidé par Masoandro</Option>
							)}

							<Option value="attente_masoandro">
								En attente de validation Masoandro
							</Option>
							<Option value="attente_client">
								En attente de validation Client
							</Option>
							<Option value="valide_client">Validé par le Client</Option>
							<Option value="invalide_client">Invalidé par le Client</Option>
							<Option value="solde">Soldé</Option>
						</Select>
					</Col>
				</Row>
			</Modal>

			<Modal
				title="Mobilisation Camions"
				open={showModalMobiliser}
				onCancel={closeMobilisationModal}
				footer={[
					<Button key="cancel" onClick={closeMobilisationModal}>
						Annuler
					</Button>,
					<Button
						key="confirm"
						type="primary"
						onClick={handleValidateMobilisation}
					>
						Confirmer
					</Button>,
				]}
				style={{ top: 15 }}
				width="70%"
			>
				{selectedCamion &&
					selectedCamion.map((item, index) => (
						<div
							key={index}
							style={{
								border: "1px solid #e5e5e5",
								borderRadius: 8,
								padding: 15,
								marginBottom: 20,
								background: "#fafafa",
							}}
						>
							{/* Ligne Camion + Coeffs */}
							<Row gutter={12} align="middle">
								<Col span={6}>
									<Select
										size="large"
										placeholder="Choisir camion"
										style={{ ...commonInputStyle, marginTop: 25 }}
										value={item.camion_id}
										onChange={(val) => {
											const camion = listeCamions.find((c) => c.id === val);
											updateCamionField(index, "camion_id", val);
											if (camion?.chauffeur_id) {
												updateCamionField(
													index,
													"chauffeur_id",
													camion.chauffeur_id
												);
											}
										}}
									>
										{listeCamions?.map((c) => (
											<Option key={c.id} value={c.id}>
												{c.imm}
											</Option>
										))}
									</Select>
								</Col>

								<Col span={6}>
									<Select
										size="large"
										placeholder="Choisir chauffeur"
										style={{
											...commonInputStyle,
											marginTop: 25,
											textAlign: "center",
										}}
										value={item.chauffeur_id}
										onChange={(val) =>
											updateCamionField(index, "chauffeur_id", val)
										}
									>
										{listeChauffeur?.map((c) => (
											<Option key={c.id} value={c.id}>
												{c.prenom}
											</Option>
										))}
									</Select>
								</Col>

								<Col span={4} style={{ textAlign: "center" }}>
									<span style={{ fontWeight: 500 }}>Coeff chargé</span>
									<Input
										value={item.coefficient_charge ?? ""}
										onChange={(e) =>
											updateCamionField(
												index,
												"coefficient_charge",
												e.target.value
											)
										}
										style={{
											...commonInputStyle,
											paddingTop: 10,
											background: "#fff",
										}}
										placeholder="ex: 0.3"
									/>
								</Col>

								<Col span={4} style={{ textAlign: "center" }}>
									<span style={{ fontWeight: 500 }}>Coeff vide</span>
									<Input
										value={item.coefficient_vide ?? ""}
										onChange={(e) =>
											updateCamionField(
												index,
												"coefficient_vide",
												e.target.value
											)
										}
										style={{
											...commonInputStyle,
											paddingTop: 10,
											background: "#fff",
										}}
										placeholder="ex: 0.3"
									/>
								</Col>

								<Col span={4} style={{ textAlign: "center" }}>
									<Button
										danger
										type="primary"
										style={{
											...commonInputStyle,
											marginTop: 26,
											textAlign: "center",
										}}
										onClick={() => removeCamion(index)}
										disabled={selectedCamion.length === 1}
									>
										Supprimer
									</Button>
								</Col>
							</Row>

							{/* Ligne compagnie + agence */}
							<Row gutter={12} style={{ marginTop: 15 }} align="middle">
								<Col span={12}>
									<label style={{ fontWeight: 500 }}>Compagnie</label>
									<Input
										placeholder="Nom de la compagnie"
										value={item.compagnie}
										onChange={(e) =>
											updateCamionField(index, "compagnie", e.target.value)
										}
										style={{ marginTop: 5 }}
									/>
								</Col>

								<Col span={12}>
									<label style={{ fontWeight: 500 }}>Agence</label>
									<Input
										placeholder="Agence"
										value={item.agence}
										onChange={(e) =>
											updateCamionField(index, "agence", e.target.value)
										}
										style={{ marginTop: 5 }}
									/>
								</Col>
							</Row>

							{/* Observation */}
							<Row style={{ marginTop: 15 }}>
								<Col span={24}>
									<TextArea
										rows={3}
										placeholder="Observation"
										value={item.observation}
										onChange={(e) =>
											updateCamionField(index, "observation", e.target.value)
										}
									/>
								</Col>
							</Row>
						</div>
					))}
				<Button type="dashed" block size="large" onClick={addCamion}>
					+ Ajouter un camion
				</Button>
			</Modal>

			<Modal
				title="Ajouter une avance"
				open={showModalAcompte}
				width={850}
				onCancel={resetAcompteModal}
				footer={[
					<Button key="cancel" onClick={resetAcompteModal}>
						Annuler
					</Button>,
					<Button key="confirm" type="primary" onClick={handleSubmitAcompte}>
						Confirmer
					</Button>,
				]}
			>
				{/* TABLEAU DES ACOMPTES */}
				<div
					style={{
						display: "flex",
						justifyContent: "flex-end",
						marginBottom: 10,
					}}
				>
					<Button
						type="primary"
						icon={<DownloadOutlined />}
						onClick={exportToExcel}
					>
						Télécharger Excel
					</Button>
				</div>

				<Table
					className="compact-table"
					columns={columnsAcomptes}
					dataSource={listeAcompte}
					rowKey="id"
					pagination={paginationConfig(5)}
					size="small"
					bordered
				/>

				{/* FORMULAIRE */}
				<Row gutter={[16, 16]} style={{ marginTop: 16 }}>
					<Col span={6}>Montant</Col>
					<Col span={18}>
						<Input
							type="number"
							value={acompte.montant}
							onChange={(e) =>
								setacompte((prev) => ({ ...prev, montant: e.target.value }))
							}
						/>
					</Col>

					<Col span={6}>Description</Col>
					<Col span={18}>
						<TextArea
							rows={2}
							value={acompte.description}
							onChange={(e) =>
								setacompte((prev) => ({
									...prev,
									description: e.target.value,
								}))
							}
						/>
					</Col>
				</Row>

				<Divider />
			</Modal>

			{showToast && <Notification message={notif.message} status={notif.info} />}
		</div>
	);
};

export default Factures;